import { faBolt, faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowPointer,
  faCircleX,
  faShieldCheck,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons';

import '../styles/componentStyles/ValueTile.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function ValueTile(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');

  return (
    <div
      className={`chart-container tile ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-value-tile-title`}
    >
      <div className="title-container empty">
        <div className="wtf">
          {props.modalText && (
            <button
              className="wtf transparent-button"
              onClick={() => props.openModal(props.title, props.modalText)}
            >
              <span className="visuallyHidden">{t('open.modal.extra.information')}</span>
              <FontAwesomeIcon icon={faQuestionCircle} className="wtf icon" />
            </button>
          )}
        </div>
      </div>
      <div className="tile-content">
        <div className="tile-value fs-mask" style={{ color: `${props.colour}` }}>
          {props.value}
        </div>
        <div className="title descr" id={`${titleId}-value-tile-title`}>
          {props.title}
        </div>
        {props.date && (
          <p className="fs-mask">
            {t('VT001')} <b>{props.date}</b>
          </p>
        )}
      </div>
    </div>
  );
}

export default ValueTile;
